<div class="view-container">
    <pm-field LabelWidth="150px" [Label]="'WidthPx'" [Content]="Grid.WidthPx"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'HeightPx'" [Content]="Grid.HeightPx"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'TopHeightPx'" [Content]="Grid.TopHeightPx"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'PanelWidthPx'" [Content]="Grid.PanelWidthPx"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'ItemsSource'" [Content]="Grid.ItemsSource ? Grid.ItemsSource.length : 0"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'Columns'" [Content]="Grid.Columns ? Grid.Columns.length : 0"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'ScrollTop'" [Content]="Grid.ScrollTop"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'VisibleRows'" [Content]="Grid.VisibleRows.length"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'VisibleColumns'" [Content]="Grid.VisibleColumns ? Grid.VisibleColumns.length : 0"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'Rows'" [Content]="Grid.Rows.length"></pm-field>    
    <pm-field LabelWidth="150px" [Label]="'ContainerHeight'" [Content]="Grid.ContainerHeight"></pm-field>    
    <pm-field LabelWidth="150px" [Label]="'TransformY'" [Content]="Grid.TransformY"></pm-field>
    <pm-field LabelWidth="150px" [Label]="'GridClass'" [Content]="Grid.GridClass"></pm-field>
    <pm-divider DividerClass="divider-thin-container"></pm-divider>
    <div class="column-filter" style="flex: 1; padding-top: 4px">        
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'RowHeight'"></pm-label>
            <pm-text-box [(Text)]="CurrentGrid.RowHeight"></pm-text-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'ColumnHeaderHeight'"></pm-label>
            <pm-text-box [(Text)]="CurrentGrid.ColumnHeaderHeight"></pm-text-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'FrozenColumnCount'"></pm-label>
            <pm-text-box [(Text)]="CurrentGrid.FrozenColumnCount"></pm-text-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'HierarchyColumnIndex'"></pm-label>
            <pm-text-box [(Text)]="CurrentGrid.HierarchyColumnIndex"></pm-text-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'HierarchyColumnProperty'"></pm-label>
            <pm-text-box [(Text)]="CurrentGrid.HierarchyColumnProperty"></pm-text-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'ShowRowNumbers'"></pm-label>
            <pm-check-box [(IsChecked)]="CurrentGrid.ShowRowNumbers"></pm-check-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'" [Label]="'ShowColumnGroups'"></pm-label>
            <pm-check-box [(IsChecked)]="CurrentGrid.ShowColumnGroups"></pm-check-box>
        </pm-stack-panel>
        <pm-stack-panel Padding="2px">
            <pm-label [style.min-width]="'150px'"
                      [Label]="'ShowRowFooter'"></pm-label>
            <pm-check-box [(IsChecked)]="CurrentGrid.ShowFooter"></pm-check-box>
        </pm-stack-panel>
    </div>
    <pm-stack-panel 
        HorizontalAlignment="Right"
        BackgroundClass="layout-gray">
        <pm-button 
            [style.margin-right.px]="5"
            (click)="OnSave()">Save</pm-button>
        <pm-button 
            [style.margin-right.px]="5"
            ButtonClass="button-standard"
            (click)="OnClose()">Close</pm-button>
    </pm-stack-panel>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/grid/grid-settings/grid-settings-general-panel.html